define(['text!./templates/wizard-page-actions.html', 'edge/platform/modelvalidation/FormUtil'], (templateStr, FormUtil)=> {
    return ['StateUtils', function (StateUtils) {
        return {
            template: templateStr,
            scope: {
                'showCancel': '=?',
                'showPrevious': '=?',
                'showNext': '=?',
                'disableCancel': '=?',
                'disablePrevious': '=?',
                'disableNext': '=?',
                'next': '=?',
                'nextLabel': '@?',
                'previous': '=?',
                'cancel': '=?',
                'gwWizardPageActions': '='
            },
            require: ['?^form', '?^ngForm'],
            link(scope, element, attrs, formCtrls) {
                const formCtrl = formCtrls[0] || {};
                const flowModel = StateUtils.activeDataForState(true).flowModel;
                const model = scope.gwWizardPageActions || StateUtils.activeDataForState(true).model;
                if (!flowModel) {
                    throw new Error('Page action directive under a wizard state that has a flowModel data property');
                }

                scope.showNext = scope.showNext || true;
                if (flowModel.steps.length > 0) {
                    const isFirstStep = flowModel.steps[0].name === flowModel.currentStep.name;
                    scope.showPrevious = (scope.showPrevious !== undefined) ? scope.showPrevious : !isFirstStep;
                }
                scope.showCancel = scope.showCancel || true;

                scope.disableCancel = scope.disableCancel || false;
                scope.disablePrevious = scope.disablePrevious || false;

                scope.goToNext = () => {
                    FormUtil.markFormsSubmitted(formCtrl);
                    if (scope.next) {
                        scope.next((_model, args) => flowModel.next(_model, args), formCtrl);
                    } else {
                        flowModel.next(model);
                    }
                };
                scope.goToPrevious = () => {
                    if (scope.previous) {
                        scope.previous((_model, args) => flowModel.previous(_model, args), formCtrl);
                    } else {
                        flowModel.previous(model);
                    }
                };
                scope.goToCancel = () => {
                    if (scope.cancel) {
                        scope.cancel((_model, args) => flowModel.cancel(_model, args), formCtrl);
                    } else {
                        flowModel.cancel(model);
                    }
                };
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/wizard/WizardPageActionsDirective.js
 **/